<clr-modal #modal [clrModalOpen]="isOpen()" (clrModalOpenChange)="isOpen.set($event)" [clrModalSize]="'xl'">
  <h3 class="modal-title">
    {{ 'Berichte verwalten' | mrTranslate }}
    @if (!saved()) {
      <span class="label label-warning">
        <span class="text">{{ 'nicht gespeichert' | mrTranslate }}</span>
      </span>
    }
  </h3>
  <div class="modal-body" style="height: 65vh; height: 65svh">
    <div class="clr-row nxm h-100">
      <div class="clr-col-lg-6 h-100">
        <h5 style="margin-top: 0">{{ 'verfügbare Berichte' | mrTranslate }}</h5>
        <div style="height: calc(100% - 24px); overflow: auto">
          <clr-tree>
            @for (group of config.BERICHTS_ARTEN; track $index) {
              <clr-tree-node [clrExpanded]="true">
                <span>{{ group.name | mrTranslate }}</span>
                @for (art of group.arten; track art.id) {
                  <clr-tree-node
                    class="basealign"
                    [clrExpanded]="berichte[art.id].expanded()"
                    (clrExpandedChange)="updateExpandedInBerichGroup($event, art.id)">
                    <span class="label" [class.label-success]="berichte[art.id].count() > 0">
                      <span class="text">{{ 'Aktive' | mrTranslate }}</span>
                      <span class="badge" [class.badge-success]="berichte[art.id].count() > 0">
                        {{ berichte[art.id].count() }}
                      </span>
                    </span>

                    <span>{{ art.titel | mrTranslate }}</span>
                    @for (alert of berichte[art.id].items(); track alert.ID ?? $index) {
                      <clr-tree-node [ngClass]="{ 'datagrid-row datagrid-selected': selectedAlert() == alert }">
                        <clr-toggle-container class="margin-0-t">
                          <clr-toggle-wrapper>
                            <input
                              type="checkbox"
                              clrToggle
                              [ngModel]="alert.active"
                              (ngModelChange)="toggleActive($event, art.id, alert)" />
                          </clr-toggle-wrapper>
                        </clr-toggle-container>
                        <a
                          href="javascript:void(0);"
                          style="color: currentColor"
                          (click)="selectedAlert.set(alert); description.set(art.description)">
                          {{ (config.REPEAT_OPTIONS[alert.termin] || 'nie') | mrTranslate | titlecase }}
                          {{ ' ' + ('an' | mrTranslate) + ' ' }}
                          {{ alert.users.nameStr || ('niemanden' | mrTranslate) }}
                        </a>
                        <button
                          type="button"
                          (click)="deleteAlert(art.id, alert)"
                          class="btn btn-sm btn-link btn-icon"
                          style="margin-left: auto; flex: 0 0 45px"
                          [title]="'Löschen' | mrTranslate">
                          <cds-icon shape="times" size="18" style="color: tomato" class="nxm" />
                        </button>
                      </clr-tree-node>
                    }
                    <clr-tree-node>
                      <a href="javascript:void(0);" (click)="newAlert(art.id); description.set(art.description)">
                        {{ 'Neu erstellen' | mrTranslate }}
                      </a>
                    </clr-tree-node>
                  </clr-tree-node>
                }
              </clr-tree-node>
            }
          </clr-tree>
        </div>
      </div>
      <div class="clr-col-lg-6 mh-100" style="overflow: auto">
        <h5 style="margin-top: 0">{{ 'Personen' | mrTranslate }}</h5>
        @let users = usersResource.value();
        @if (users?.rows.length) {
          <clr-datagrid
            #userDg
            [clrDgItemsIdentityFn]="row => row?.id"
            [clrDgSelectionType]="'multi'"
            [clrDgSelected]="selectedUsers()"
            (clrDgSelectedChange)="selectedUsers.set($event); updateUsersInAlert()"
            class="datagrid-compact dg-overflow-fix"
            style="max-height: 30svh"
            [appClrCheckboxDisplay]="!!selectedAlert()">
            @for (column of users.columns; track column.id) {
              <clr-dg-column [clrDgField]="column.id">
                <ng-container
                  *clrDgHideableColumn="{
                    hidden: column.id | hideIDColumns: ['userimagebase64', 'status', 'username', 'alias', 'kprolid'],
                  }">
                  {{ column.id | mrTranslate }}
                </ng-container>
              </clr-dg-column>
            }
            <clr-dg-row *clrDgItems="let row of users.rows" [clrDgItem]="row" [clrDgSelectable]="!!selectedAlert()">
              @for (cell of users.columns; track cell.id) {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            </clr-dg-row>
            <clr-dg-footer>{{ users.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
          </clr-datagrid>
        }
        <div class="clr-row nxm">
          <h5 class="clr-col-12">{{ 'Einstellungen' | mrTranslate }}</h5>
          <div class="clr-col-6">
            <clr-radio-container class="margin-6-t">
              <label class="clr-col-12 clr-col-md-12">
                {{ 'Bericht erstellen' | mrTranslate }}
              </label>
              @for (termin of config.REPEAT_OPTIONS | keyvalue; track termin.key) {
                <clr-radio-wrapper>
                  <label>{{ termin.value | mrTranslate }}</label>
                  <input
                    name="termin"
                    type="radio"
                    clrRadio
                    [value]="termin.key"
                    [disabled]="!selectedAlert()"
                    [ngModel]="selectedAlert()?.termin"
                    (ngModelChange)="updateTerminInAlert($event)" />
                </clr-radio-wrapper>
              }
            </clr-radio-container>
          </div>
          <div class="clr-col-6">
            <clr-radio-container class="margin-6-t">
              <label class="clr-col-12 clr-col-md-12">
                {{ 'Export Format' | mrTranslate }}
              </label>
              <clr-radio-wrapper>
                <label>{{ '*.xlsx' }}</label>
                <input
                  [disabled]="!selectedAlert()"
                  name="format"
                  type="radio"
                  clrRadio
                  [value]="0"
                  [ngModel]="selectedAlert()?.format"
                  (ngModelChange)="updateFormatInAlert($event)" />
              </clr-radio-wrapper>
              <clr-radio-wrapper>
                <label>{{ '*.pdf' }}</label>
                <input
                  [disabled]="!selectedAlert()"
                  name="format"
                  type="radio"
                  clrRadio
                  [value]="1"
                  [ngModel]="selectedAlert()?.format"
                  (ngModelChange)="updateFormatInAlert($event)" />
              </clr-radio-wrapper>
            </clr-radio-container>
          </div>
          <h5 class="clr-col-12">{{ 'Beschreibung' | mrTranslate }}</h5>
          <span class="clr-col-12">
            {{ (description() ?? 'Wählen Sie eine Konfiguration des Berichts') | mrTranslate }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="saveBerichteConfig()">
      {{ 'Speichern' | mrTranslate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="modal.close()">
      {{ (saved() ? 'Schliessen' : 'Abbrechen') | mrTranslate }}
    </button>
  </div>
</clr-modal>
